export default __webpack_public_path__ + "static/media/include_3@3x.c7b88e29.jpg";